import { DHTco } from '../../../types/design-huddle.types'
import { FLOWCODE_HOST } from '@dtx-company/true-common/src/constants/root'
import { FlowcodeType } from '@dtx-company/inter-app/src/types/flowcode'

export const DESIGN_HUDDLE_SCRIPT_SRC = 'https://cdn.designhuddle.com/editor/v1/lib.js'
export const DESIGN_HUDDLE_DOMAIN = 'flowcode.designhuddle.com'
export const DESIGN_HUDDLE_CLIENT_ID = 't02i0hc1d9csy70t6p5f'

export const DEFAULT_FLOWCODE_IMAGE_URL =
  'https://images.prismic.io/flowcode-ui/e42844fa-5a2e-4496-bc92-5680a0c974a8_design-huddle-default-flowcode-image.png?auto=compress,format'
export const DEFAULT_LOGO_IMAGE_URL =
  'https://images.prismic.io/flowcode-ui/9905b595-87fe-4131-bbbc-b42ad7baba44_design-huddle-default-logo-image.png?auto=compress,format'

export const DEFAULT_TCO: DHTco = {
  primaryText: {
    text: 'SCAN THE FLOWCODE'
  },
  scanDestinationText: {
    text: FLOWCODE_HOST,
    auto_fit: true
  },
  flowcodeImage: {
    url: DEFAULT_FLOWCODE_IMAGE_URL
  },
  logoImage: {
    url: DEFAULT_LOGO_IMAGE_URL
  }
}

export const IFRAME_CONTAINER_ID = 'design-huddle-editor'

export const initialCodeData: FlowcodeType = {
  id: '',
  nickname: undefined,
  activeLink: {
    id: '',
    redirectValue: '',
    shorturl: '',
    redirectType: ''
  },
  domain: '',
  lastModified: '',
  timeStamp: '',
  analytics: {},
  studioConfig: {
    id: '',
    configuration: null,
    isCustomizable: false,
    source: '',
    name: ''
  },
  batchOwner: {
    isOwner: false
  }
}

/**
 * We use [requestAnimationFrame](https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame)
 * to check if the DSHDEditorLib property is available on the window object. Generally, there are 60 frames per second,
 * so we're checking for up to approximately 3 seconds after the script has loaded.
 */
export const MAX_WAIT_FOR_DH_SCRIPT_RETRIES = 180
